import { render, staticRenderFns } from "./PipelineFence.vue?vue&type=template&id=23e54945&scoped=true&"
import script from "./PipelineFence.vue?vue&type=script&lang=js&"
export * from "./PipelineFence.vue?vue&type=script&lang=js&"
import style0 from "./PipelineFence.vue?vue&type=style&index=0&id=23e54945&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e54945",
  null
  
)

export default component.exports